import React, { useEffect, useState } from "react";
import BreadCrum from "../../components/common/BreadCrum";
import Input from "../../components/common/input";
import { addbank, getCLinicById } from "../../hooks/services/api-services";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import { useSelector } from "react-redux";
import {
  handleFormInput,
  hasValidationErrors,
  restrictInputByRegex,
} from "../../utils/form-utils";
import Button from "../../components/common/button";
import BankDetailes from "./doctor-bank-detailes";
import { REGEX } from "../../utils/regexValidation";
import TableHeading from "../../components/common/TableHeading";
import { useTranslation } from "react-i18next";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import { API_RESPONSE } from "../../utils/app-constants";

const BankManagemnet = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [userbtndisable, setuserbtndisable] = useState(true);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const [formError, setFormError] = useState({});
  const [payload, setPayload] = useState({
    id: 0,
    bankName: "",
    iban: "",
    bankAddress: "",
    nationalId: "",
    sirenNo: "",
    swiftBicCode: "",
    branchName: "",
    languageType: i18n.language,
    clinicId: "",
    clinicName: "",
    countryName: userData.country,
    email: ""
  });

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    try {
      const response = await getCLinicById(
        userData?.id, i18n.language,
        userData?.loginClinicType ? 0 : userData?.adminResponsePayload?.id == null ? 0 : userData?.adminResponsePayload?.id
      );
      const data = response?.data?.data?.bankDetailsResponseList;
      if (data) {
        setPayload({
          id: data.id,
          bankName: data.bankName,
          iban: data.iban,
          nationalId: data.nationalId,
          sirenNo: data.sirenNo,
          swiftBicCode: data.swiftBicCode,
          branchName: data.branchName,
          languageType: data.languageType,
          clinicId: data.clinicId,
          clinicName: data.clinicName,
          countryName: userData.country,
          // country:userData.country,
          email: data.email,

        });
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (payload?.clinicName?.trim() === "") {
      return toastEmitter("error", "Clinic Name is mandatory!");
    }
    if (payload?.iban?.trim() === "") {
      return toastEmitter("error", "IBAN  is mandatory!");
    }
    if (payload?.countryName?.trim() === "") {
      return toastEmitter("error", "Country Name  is mandatory!");
    }
    if (payload?.bankName?.trim() === "") {
      return toastEmitter("error", "Bank Name  is mandatory!");
    }
    if (payload?.email?.trim() === "") {
      return toastEmitter("error", "email is mandatory!");
    }
    if (hasValidationErrors(formError)) {
      toastEmitter("error", "Please correct the errors before submitting.");
      return;
    }
    if (
      userData?.country === "Saudi Arabia" ||
      userData?.country === "Germany" ||
      userData?.country === "United Arab Emirates"
    ) {
      if (payload?.nationalId?.trim() === "") {
        return toastEmitter(
          "error",
          "Commercial Registration (CR) number/National ID/Emirates Id is mandatory!"
        );
      }
    }
    if (userData?.country === "France") {
      if (payload?.sirenNo?.trim() === "") {
        return toastEmitter("error", "SIRET/SIREN number is mandatory!");
      }
    }

    setIsLoading(true);
    try {
      const response = await addbank(payload);
      if (response?.data?.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        setuserbtndisable(true);
      }
    } catch (err) {
      toastEmitter(
        "error",
        err.message || "Something went wrong. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };
  const addButtonClick = () => {
    setuserbtndisable(false);
  };

  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);
  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v?.moduleName === "Bank Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);
  // permission code for this module end
  return (
    <div>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <div className="main_datatable my-lg-3 my-2 bank_tabs">
          <BreadCrum
            firstData={t("Bank Management")}
            className="fw-600 fs-20"
          />
          <ul className="nav nav-pills gap-2 mb-md-0 mb-2" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation ">
              <button
                className="nav-link active mb-2"
                id="pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                {t("My Bank")}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link  ms-sm-2 ms-0 mb-2 ${i18n.language === "ar" ? "me-0 me-sm-2" : ""
                  }`}
                id="pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-profile"
                type="button"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                {t("Doctor's Bank")}
              </button>
            </li>
          </ul>

          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <TableHeading
                title={t("My Bank Information")}
                data="Edit"
                showsearchinput={false}
                showbutton={false}
                addButtonClick={addButtonClick}
                showEditButton={permissionAccess?.updateAction === 1}
              />
              <form onSubmit={handleSubmit}>
                <div className="add_doctor card p-3 border border-radius_input">
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload?.clinicName}
                        name="clinicName"
                        placeHolder="Enter Clinic Name"
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        labelName="Clinic Name"
                        disabled={true}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload.email}
                        name="email"
                        placeHolder="Enter Email"
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        showIcon={false}
                        labelName="Paypal Email"
                        disabled={userbtndisable}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload?.iban}
                        name="iban"
                        placeHolder="Enter IBAN"
                        onBeforeInput={restrictInputByRegex(
                          REGEX.charLevelAlphaNumeric
                        )}
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        labelName="International Bank Account No."
                        disabled={userbtndisable}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload?.countryName}
                        name="countryName"
                        placeHolder="countryName"
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        showIcon={false}
                        labelName="Country Name"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload?.bankName}
                        name="bankName"
                        placeHolder="Enter Bank Name"
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        labelName="Bank Name"
                        disabled={userbtndisable}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        className="border-radius_input"
                        type="text"
                        value={payload?.swiftBicCode}
                        name="swiftBicCode"
                        placeHolder="Enter SWIFT/BIC Code"
                        handleChange={(e) =>
                          setPayload(handleFormInput(e, payload))
                        }
                        error={formError?.swiftBicCode}
                        showIcon={false}
                        onBeforeInput={restrictInputByRegex(
                          REGEX.charLevelAlphaNumeric
                        )}
                        showAsterisk={false}
                        labelName="SWIFT/BIC Code (Optional)"
                        disabled={userbtndisable}
                      />
                    </div>

                    {userData &&
                      (userData?.country === "Saudi Arabia" ||
                        userData?.country === "United Arab Emirates" ||
                        userData?.country === "Germany") && (
                        <div className="col-12 col-md-6">
                          <Input
                            className="border-radius_input"
                            type="text"
                            value={payload?.nationalId}
                            name="nationalId"
                            placeHolder="Enter CR Number"
                            handleChange={(e) =>
                              setPayload(handleFormInput(e, payload))
                            }
                            error={formError?.nationalId}
                            showIcon={false}
                            onBeforeInput={restrictInputByRegex(
                              REGEX.charLevelAlphaNumeric
                            )}
                            labelName="Commercial Registration (CR) number/National ID or Iqama number/Emirates"
                            disabled={userbtndisable}
                          />
                        </div>
                      )}

                    {userData && userData?.country === "France" && (
                      <div className="col-12 col-md-6">
                        <Input
                          className="border-radius_input"
                          type="text"
                          value={payload?.sirenNo}
                          name="sirenNo"
                          placeHolder="Enter Your SIREN"
                          onBeforeInput={restrictInputByRegex(
                            REGEX.charLevelAlphaNumeric
                          )}
                          handleChange={(e) =>
                            setPayload(handleFormInput(e, payload))
                          }
                          error={formError?.sirenNo}
                          showIcon={false}
                          labelName="SIRET/SIREN Number"
                          disabled={userbtndisable}
                        />
                      </div>
                    )}
                    {!userbtndisable && (
                      <div className="d-flex justify-content-center mt-3">
                        <Button
                          type="button"
                          className={`px-5 py-2 rounded border-0  cancelbtn ${i18n.language === "ar" ? "ms-2" : "me-2"}`}
                          label="Cancel"
                          onClick={() => setuserbtndisable(true)}
                        />
                        <Button
                          type="submit"
                          className="px-5 py-2 rounded border-0 text-white submitbtn"
                          label="Save Changes"
                          isLoading={isLoading}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <BankDetailes />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankManagemnet;
